import Task from 'models/tasks/task';

export interface ITaskPivotCounts {
  context?: number;
  resources?: number;
  checklist?: number;
  activity?: number;
}

// Undefined (rather than 0) suppresses the "(0)" suffix Fluent's Pivot renders for itemCount.
const toItemCount = (count: number): number | undefined => (count > 0 ? count : undefined);

export const getTaskPivotCounts = (task: Task): ITaskPivotCounts => {
  const context =
    (task.controlIds?.length ?? 0) +
    (task.processIds?.length ?? 0) +
    (task.objectiveIds?.length ?? 0) +
    (task.riskIds?.length ?? 0) +
    (task.assetIds?.length ?? 0) +
    (task.processingActivityIds?.length ?? 0) +
    (task.taskRelations?.length ?? 0);

  return {
    context: toItemCount(context),
    resources: toItemCount(task.resourceLinkIds?.length ?? 0),
    checklist: toItemCount(task.checkList?.items?.length ?? 0),
  };
};
